import UserMenu from "@/components/UserMenu";
import { useNavbarUserMenu } from "@/hooks/useNavbarUserMenu";

const NavbarUserMenu = () => {
  const { userInfo, brugerNavn, userSubtitles, showAccountLink, menuUserInfo } =
    useNavbarUserMenu();

  if (userInfo && brugerNavn) {
    return (
      <UserMenu
        userName={brugerNavn}
        subtitles={userSubtitles}
        showAccountLink={showAccountLink}
        userInfo={menuUserInfo}
      />
    );
  }

  if (userInfo) {
    return (
      <UserMenu
        userName="Gæst (via link)"
        variant="guest"
        showAccountLink={false}
      />
    );
  }

  return null;
};

export default NavbarUserMenu;
